
<el-container
  :class="['dfx-container', showHeader ? 'dfx-container-header' : '']"
>
  <el-header v-if="showHeader">
    <Headers />
  </el-header>
  <el-container class="dfx-content">
    <el-aside
      :width="asideWidth"
      class="dfx-aside no-shk"
      :style="{ backgroundColor: bgColog, width: asideWidth }"
      :bgColor="bgColog"
      activeTextColor="#000"
    >
      <div class="logo">
        <el-image
          src="//oss.dianleida.net/1688-web/images/long_logo.png"
        ></el-image>
      </div>
      <Aside />
    </el-aside>
    <el-main class="dfx-views">
      <div class="cmd row-end-center dfx-my-10 dfx-px-20">
        <div class="dfx-mr-12 screen-box" v-if="buildType === 'App' && dldId">
          <el-button size="small" @click="handleFullScreen">
            <div class="dfc">
              <i class="el-icon-full-screen dfx-c-them dfx-f-15"></i>
              <span>{{ fullscreenBody ? t("还原") : t("全屏") }}</span>
            </div>
          </el-button>
          <div class="screen-tip dfc" v-if="showScreenTip">
            <img
              src="//oss.dianleida.net/1688-web/images/hand.png"
              alt=""
              width="32"
              class="dfx-w32"
            />
            <span class="no-shk dfx-ml-5">{{
              fullscreenBody ? t("点击可还原全屏") : t("点击可展开全屏")
            }}</span>
            <i
              class="el-icon-close dfx-f-15 dfx-ml-10 curp"
              @click="closeScreenTip"
            ></i>
          </div>
        </div>
        <el-button
          size="small"
          @click="
            $utils.openUrl(
              'https://www.yuque.com/akeake-sfyp2/mg8av9/usroelnshgko3qr3?singleDoc#'
            )
          "
          ><i
            class="dfx-iconfont icon-xuanfu-caozuoshouce dfx-mr-4 dfx-c-them"
          ></i
          >{{ t("教程") }}</el-button
        >
        <Kefu size="small" class="dfx-mx-12" />
        <el-button
          size="small"
          @click="$router.push('/apply/personalManage/toolOrder')"
          ><i
            class="el-icon-shopping-cart-2 dfx-mr-4 dfx-f-16 dfx-c-danger"
          ></i
          >{{ t("购买") }}</el-button
        >
        <!-- <el-button size="small" @click="buyPackage()"
          ><i
            class="dfx-iconfont icon-dinggouguanli dfx-mr-4 dfx-f-16 dfx-c-them"
          ></i
          >增值包购买</el-button
        > -->
        <!-- <el-button size="small" @click="bindPhone"
          ><i class="el-icon-mobile-phone dfx-mr-4 dfx-f-16"></i
          >绑定手机</el-button
        > -->
        <UserInfo class="dfx-ml-12 dfx-f-14 dfx-h36 dfx-lh-36" />
      </div>
      <div class="dfx-view-router">
        <router-view />
      </div>
    </el-main>
  </el-container>
  <!-- <Login ref="Login" /> -->
  <AddShop ref="AddShop" />
  <PackageDialog ref="PackageDialog" />
  <PackageTipDialog ref="PackageTipDialog" />
  <meituDialog ref="meituDialog" />
  <ProgressDialog ref="ProgressDialog" />
  <!-- <BindAccount ref="BindAccount" /> -->
</el-container>
